import { render, staticRenderFns } from "./AdviceConfirmSaveAdvices.vue?vue&type=template&id=0e9bcbe0&scoped=true&"
import script from "./AdviceConfirmSaveAdvices.vue?vue&type=script&lang=js&"
export * from "./AdviceConfirmSaveAdvices.vue?vue&type=script&lang=js&"
import style0 from "./AdviceConfirmSaveAdvices.vue?vue&type=style&index=0&id=0e9bcbe0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9bcbe0",
  null
  
)

export default component.exports